import { LoadHandover } from './load-handover.model';

export class LoadHandoverGroup {

  public latitude: number;
  public longitude: number;
  public loadHandovers: LoadHandover[] = [];
  public firstLoadHandover: LoadHandover;
  public firstOldLoadHandover: LoadHandover;

  public hasAnyOldLoadHandover   = false;
  public hasSelectedLoadHandover = false;
  public address: string;

  public nbLoadHandovers    = 0;
  public nbOldLoadHandovers = 0;

  static fromDto(g: any): LoadHandoverGroup {
    if (!g) {
      return null;
    }

    const group = new LoadHandoverGroup();

    group.latitude  = g.latitude;
    group.longitude = g.longitude;

    if (g.load_handovers) {
      group.loadHandovers = g.load_handovers.map(h => LoadHandover.fromDto(h));
    }

    group.hasAnyOldLoadHandover   = group.loadHandovers.some(l => l.isOld);
    group.hasSelectedLoadHandover = false;

    group.firstLoadHandover    = group.loadHandovers[0];
    group.firstOldLoadHandover = group.getOldLoadHandovers()[0];

    group.nbLoadHandovers = group.loadHandovers.length;
    group.nbOldLoadHandovers = group.getOldLoadHandovers().length;

    return group;
  }

  getOldLoadHandovers(): LoadHandover[] {
    return this.loadHandovers.filter(h => h.isOld);
  }
}
